import React, { useEffect, useState } from 'react';
import { useWidgetDndContextData } from 'src/context/WidgetDndContext';
import { COMMON_LAYOUT_TYPE } from '../../ListPresentationV1/components/Testimonials/Constants';
import { leftArrow, rightArrow } from '../svg/svgList';
import { isMobileDevice } from 'src/components/WidgetMaker/WidgetDnD/isMobileDevice';
import { buttonStyle, globalStyleValue } from 'src/utils/globalStyleHelper';
import { useSSRSelector } from 'src/redux/ssrStore';

const PaginationComponent = ({ totalPages, loadSelectedPageData }) => {
  const {
    widgetContextState: { pageStyle, globalStyle },
  } = useWidgetDndContextData();
  const isMobile = isMobileDevice();
  const { store } = useSSRSelector(
    (state) => ({
      store: state.storeReducer?.store,
    })
  );

  const { gridAndPagination } = pageStyle;
  const { pagination_appearance } = gridAndPagination;
  const boxRadius = buttonStyle(globalStyle, 8, false);
  const borderRadiusVal = globalStyleValue(boxRadius?.borderRadius);
  const themeColor = globalStyle?.color?.themeColor || store?.theme?.colors?.primary_color


  const visibleCount = 5;
  const midIndex = Math.floor(visibleCount / 2);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    setCurrentPage(1);
  }, [totalPages]);

  const getVisiblePages = () => {
    let start = Math.max(1, currentPage - midIndex);
    let end = start + visibleCount - 1;

    if (end > totalPages) {
      end = totalPages;
      start = Math.max(1, end - visibleCount + 1);
    }

    return Array.from({ length: end - start + 1 }, (_, i) => start + i);
  };

  const visiblePages = getVisiblePages();

  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
      loadSelectedPageData(page)
    }
  };

  return (
    <div className={`tw-flex ${!isMobile ? 'tw-items-center tw-justify-between' : 'tw-flex-col-reverse tw-items-center tw-justify-center tw-gap-[20px]'} `}>
      <div className='tw-text-[15px] tw-font-normal tw-text-[#667479] '>{`Pages ${currentPage} of ${totalPages}`}</div>
      <div className="tw-flex tw-items-center tw-gap-[16px]">
        <div
          onClick={() => goToPage(currentPage - 1)}
          className={`${currentPage === 1 ? 'tw-opacity-50 tw-pointer-events-none' : 'tw-cursor-pointer'} tw-mt-[5px]`}
        >
          {pagination_appearance === COMMON_LAYOUT_TYPE.TWO ? <span className={`tw-text-[12px] tw-font-medium tw-text-newBlack ${currentPage === 1 ? 'tw-opacity-50 tw-pointer-events-none' : ''}`}>{'Previous'}</span>
            : leftArrow(currentPage === 1 ? '#BCBCBC' : '#111C36')}
        </div>

        {visiblePages.map((page) => (
          <div
            key={page}
            onClick={() => goToPage(page)}
            style={{ borderRadius: borderRadiusVal, borderColor: currentPage === page ? themeColor : '#111C361F',
               background: (pagination_appearance === COMMON_LAYOUT_TYPE.THREE && currentPage === page) ? themeColor : '',
               color: (pagination_appearance === COMMON_LAYOUT_TYPE.THREE && currentPage === page) ? 'white' : ''
               }}
            className={`tw-flex tw-items-center tw-justify-center tw-h-[40px] tw-w-[40px]
             tw-border tw-border-solid 
             tw-text-[14px] tw-font-normal tw-text-newBlack tw-cursor-pointer ${currentPage === page ? ' tw-font-bold ' : pagination_appearance === COMMON_LAYOUT_TYPE.THREE ? 'tw-border-none' : ''}`}
          >
            <span className={``}>{page}</span>
          </div>
        ))}

        <div
          onClick={() => goToPage(currentPage + 1)}
          className={`${currentPage === totalPages ? 'tw-opacity-50 tw-pointer-events-none' : 'tw-cursor-pointer'} tw-mt-[5px]`}
        >
          {pagination_appearance === COMMON_LAYOUT_TYPE.TWO ? <span className={`tw-text-[12px] tw-font-medium tw-text-newBlack ${currentPage === totalPages ? 'tw-opacity-50 tw-pointer-events-none' : ''}`}>{'Next'}</span>
            : rightArrow(currentPage === totalPages ? '#BCBCBC' : '#111C36')} </div>
      </div>
      {!isMobile && <div></div>}
    </div>
  );
};

export default PaginationComponent;
